import { IReview } from "@Interfaces/Api/Review";
import { ApiCore } from "@Services/API/Core";
import { apiProvider } from "@Services/API/Provider";

const url = "product/review";
const ApiReview = new ApiCore<IReview>({
  getAll: true,
  getSingle: true,
  remove: false,
  url: url,
  post: true,
  put: true,
  patch: false,
});

ApiReview.getAllByProductId = (
  productId: string | number,
  page: number = 1,
  perPage: number = 10,
  otherQueryParam: string = ""
) => {
  return apiProvider.getAll(
    `${url}/${productId}?page=${page}&perPage=${perPage}${otherQueryParam}`
  );
};

ApiReview.myReview = (id: string) => {
  {
    return apiProvider.getAll(`product/${id}/my-review`);
  };
}

export { ApiReview };
